// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_4e5f713ae4--pagination--AOIXx","pages-list":"_4e5f713ae4--pages-list--JVrVk","page":"_4e5f713ae4--page--mGKWs"};